import React, { forwardRef } from 'react';

interface AttachmentInputProps {
  accept?: string;
  ariaControls: string;
  dataQa: string;
  multiple?: boolean;
  onFileSelected: (files: File[]) => void;
}

const AttachmentInput = forwardRef<HTMLInputElement, AttachmentInputProps>(
  ({ accept, ariaControls, dataQa, multiple = false, onFileSelected }, ref) => {
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
      const files = Array.from(event.target.files || []);

      // clear the input value, so that the same file can be uploaded again
      if (ref && 'current' in ref && ref.current) {
        const inputElement = ref.current as HTMLInputElement;
        inputElement.value = '';
      }

      if (files) {
        onFileSelected(files);
      }
    };

    return (
      <input
        accept={accept}
        aria-controls={ariaControls}
        data-qa={dataQa}
        multiple={multiple}
        ref={ref}
        style={{ display: 'none' }}
        type="file"
        onChange={handleFileChange}
      />
    );
  }
);

AttachmentInput.displayName = 'AttachmentInput';

export default AttachmentInput;
